export const removeDoubleQuotes = (str: string): string => {
  if (typeof str !== 'string') return;
  return str?.replace(/"/g, '');
};
